import { ImgHTMLAttributes } from 'react';

interface OptimizedImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  src: string;
  webpSrc?: string;
  alt: string;
  fetchPriority?: 'high' | 'low' | 'auto';
}

/**
 * Optimized image component that uses WebP format with fallback
 * Automatically handles responsive images with proper loading attributes
 */
export const OptimizedImage = ({ 
  src, 
  webpSrc, 
  alt, 
  className,
  fetchPriority = 'auto',
  loading = 'lazy',
  ...props 
}: OptimizedImageProps) => {
  // If no WebP source provided, just render regular img
  if (!webpSrc) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        loading={loading}
        fetchPriority={fetchPriority}
        {...props}
      />
    );
  }

  // Render picture element with WebP and fallback
  return (
    <picture>
      <source srcSet={webpSrc} type="image/webp" />
      <img
        src={src}
        alt={alt}
        className={className}
        loading={loading}
        fetchPriority={fetchPriority}
        {...props}
      />
    </picture>
  );
};
